import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { MatSidenav } from '@angular/material';

@Component({
  selector: 'app-topnavigation',
  templateUrl: './topnavigation.component.html',
  styleUrls: ['./topnavigation.component.less']
})
export class TopnavigationComponent implements OnInit {
  opened: boolean = false;

  @ViewChild('sidenav', {static: false}) sidenav: MatSidenav;

  constructor(private data: DataService) { }

  ngOnInit() {
    this.data.mobileMenu.subscribe(state => {
      if(state == false) {
        this.opened = state;
      }
    })
  }

  toggleMobileMenu(){
    this.opened = !this.opened
    this.data.toggleMobileMenu(this.opened);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event){
    if(this.opened == true){
      this.opened = false;
      this.data.toggleMobileMenu(this.opened);
    }
  }
}
